module.exports = __webpack_public_path__ + "311a5be223f64703373ce30d37a501da.svg";